// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/spend_management/memberships/memberships/firstparty/v1/membership.proto

/* oxlint-disable */

/** Represents all possible membership statuses */
export const ApiMembershipStatus = {
  /** MEMBERSHIP_STATUS_UNSPECIFIED - The status has not been specified */
  MEMBERSHIP_STATUS_UNSPECIFIED: "MEMBERSHIP_STATUS_UNSPECIFIED",
  /**
   * invited - Membership is in invited state
   */
  invited: "invited",
  /**
   * active - Membership is active
   */
  active: "active",
  /**
   * revoked - Membership is revoked
   */
  revoked: "revoked",
} as const;

export type ApiMembershipStatus = typeof ApiMembershipStatus[keyof typeof ApiMembershipStatus];

export namespace ApiMembershipStatus {
  export type MEMBERSHIP_STATUS_UNSPECIFIED = typeof ApiMembershipStatus.MEMBERSHIP_STATUS_UNSPECIFIED;
  export type invited = typeof ApiMembershipStatus.invited;
  export type active = typeof ApiMembershipStatus.active;
  export type revoked = typeof ApiMembershipStatus.revoked;
}

export function apiMembershipStatusFromJSON(object: any): ApiMembershipStatus {
  switch (object) {
    case 0:
    case "MEMBERSHIP_STATUS_UNSPECIFIED":
      return ApiMembershipStatus.MEMBERSHIP_STATUS_UNSPECIFIED;
    case 1:
    case "invited":
      return ApiMembershipStatus.invited;
    case 2:
    case "active":
      return ApiMembershipStatus.active;
    case 3:
    case "revoked":
      return ApiMembershipStatus.revoked;
    default:
      return ApiMembershipStatus.MEMBERSHIP_STATUS_UNSPECIFIED;
  }
}

export function apiMembershipStatusToJSON(object: ApiMembershipStatus): string {
  switch (object) {
    case ApiMembershipStatus.MEMBERSHIP_STATUS_UNSPECIFIED:
      return "MEMBERSHIP_STATUS_UNSPECIFIED";
    case ApiMembershipStatus.invited:
      return "invited";
    case ApiMembershipStatus.active:
      return "active";
    case ApiMembershipStatus.revoked:
      return "revoked";
    default:
      return "MEMBERSHIP_STATUS_UNSPECIFIED";
  }
}

/** Represents all possible membership roles */
export const ApiMembershipRole = {
  /** MEMBERSHIP_ROLE_UNSPECIFIED - The role has not been specified */
  MEMBERSHIP_ROLE_UNSPECIFIED: "MEMBERSHIP_ROLE_UNSPECIFIED",
  /**
   * owner - Organization owner
   */
  owner: "owner",
  /**
   * admin - Administrator
   */
  admin: "admin",
  /**
   * manager - Manager role
   */
  manager: "manager",
  /**
   * employee - Employee role
   */
  employee: "employee",
  /**
   * accountant - Accountant role
   */
  accountant: "accountant",
} as const;

export type ApiMembershipRole = typeof ApiMembershipRole[keyof typeof ApiMembershipRole];

export namespace ApiMembershipRole {
  export type MEMBERSHIP_ROLE_UNSPECIFIED = typeof ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED;
  export type owner = typeof ApiMembershipRole.owner;
  export type admin = typeof ApiMembershipRole.admin;
  export type manager = typeof ApiMembershipRole.manager;
  export type employee = typeof ApiMembershipRole.employee;
  export type accountant = typeof ApiMembershipRole.accountant;
}

export function apiMembershipRoleFromJSON(object: any): ApiMembershipRole {
  switch (object) {
    case 0:
    case "MEMBERSHIP_ROLE_UNSPECIFIED":
      return ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED;
    case 1:
    case "owner":
      return ApiMembershipRole.owner;
    case 2:
    case "admin":
      return ApiMembershipRole.admin;
    case 3:
    case "manager":
      return ApiMembershipRole.manager;
    case 4:
    case "employee":
      return ApiMembershipRole.employee;
    case 5:
    case "accountant":
      return ApiMembershipRole.accountant;
    default:
      return ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED;
  }
}

export function apiMembershipRoleToJSON(object: ApiMembershipRole): string {
  switch (object) {
    case ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED:
      return "MEMBERSHIP_ROLE_UNSPECIFIED";
    case ApiMembershipRole.owner:
      return "owner";
    case ApiMembershipRole.admin:
      return "admin";
    case ApiMembershipRole.manager:
      return "manager";
    case ApiMembershipRole.employee:
      return "employee";
    case ApiMembershipRole.accountant:
      return "accountant";
    default:
      return "MEMBERSHIP_ROLE_UNSPECIFIED";
  }
}

/** Represents a membership. */
export interface ApiMembership {
  /** Unique identifier of the membership. */
  readonly id: string;
  /** Unique identifier of the user. */
  readonly userId?:
    | string
    | null
    | undefined;
  /** Organization ID this membership belongs to */
  readonly organizationId: string;
  /** Status of the membership */
  readonly status: ApiMembershipStatus;
  /** Role assigned to the membership */
  readonly role: ApiMembershipRole;
  /** Team ID this membership belongs to (optional) */
  readonly teamId?:
    | string
    | null
    | undefined;
  /** Name of the team (optional) */
  readonly teamName?: string | null | undefined;
}

export const ApiMembership: MessageFns<ApiMembership> = {
  fromJSON(object: any): ApiMembership {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : null,
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      status: isSet(object.status)
        ? apiMembershipStatusFromJSON(object.status)
        : ApiMembershipStatus.MEMBERSHIP_STATUS_UNSPECIFIED,
      role: isSet(object.role) ? apiMembershipRoleFromJSON(object.role) : ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED,
      teamId: isSet(object.teamId) ? globalThis.String(object.teamId) : null,
      teamName: isSet(object.teamName) ? globalThis.String(object.teamName) : null,
    };
  },

  toJSON(message: ApiMembership): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.userId !== undefined && message.userId !== null) {
      obj.userId = message.userId;
    }
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organizationId = message.organizationId;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiMembershipStatusToJSON(message.status);
    }
    if (message.role !== undefined && message.role !== null) {
      obj.role = apiMembershipRoleToJSON(message.role);
    }
    if (message.teamId !== undefined && message.teamId !== null) {
      obj.teamId = message.teamId;
    }
    if (message.teamName !== undefined && message.teamName !== null) {
      obj.teamName = message.teamName;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
